<div class="px-4 py-5 md:px-6 lg:px-8">
  <div class="grid">
      <div class="col-12 md:col-6 lg:col-3">
          <div class="surface-card shadow-2 p-3 border-round">
              <div class="flex justify-content-between mb-3">
                  <div>
                    <h3 class="fs-2">Users</h3>
                    <p>Handle the Users</p>
                    <p-button (click)="onNavigate('Users')" class="btn btn-primary">Users</p-button>
                  </div>
                  <div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width:2.5rem;height:2.5rem">
                      <i class="pi pi-map-marker text-orange-500 text-xl"></i>
                  </div>
              </div>
              <span class="text-green-500 font-medium">%52+ </span>
              <span class="text-500">since last week</span>
          </div>
      </div>
      <div *ngIf="isAdminUser"
      class="col-12 md:col-6 lg:col-3">
          <div class="surface-card shadow-2 p-3 border-round">
              <div class="flex justify-content-between mb-3">
                  <div>
                    <h3 class="fs-2">Clients</h3>
                    <p>Handle the Clients</p>
                    <p-button (click)="onNavigate('Clients')" class="btn btn-primary">Clients</p-button>
                  </div>
                  <div class="flex align-items-center justify-content-center bg-cyan-100 border-round" style="width:2.5rem;height:2.5rem">
                      <i class="pi pi-inbox text-cyan-500 text-xl"></i>
                  </div>
              </div>
              <span class="text-green-500 font-medium">520  </span>
              <span class="text-500">newly registered</span>
          </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
                <div>
                  <h3 class="fs-2">Products</h3>
                  <p>Handle Products</p>
                  <p-button (click)="onNavigate('Products')" class="btn btn-primary">Products</p-button>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-shopping-cart text-blue-500 text-xl"></i>
                </div>
            </div>
            <span class="text-green-500 font-medium">24 new </span>
            <span class="text-500">since last visit</span>
        </div>
    </div>
      <div class="col-12 md:col-6 lg:col-3">
          <div class="surface-card shadow-2 p-3 border-round">
              <div class="flex justify-content-between mb-3">
                  <div>
                    <h3 class="fs-2">Services</h3>
                    <p>Handle the Services</p>
                    <p-button (click)="onNavigate('Services')" class="btn btn-primary">Services</p-button>
                  </div>
                  <div class="flex align-items-center justify-content-center bg-purple-100 border-round" style="width:2.5rem;height:2.5rem">
                      <i class="pi pi-comment text-purple-500 text-xl"></i>
                  </div>
              </div>
              <span class="text-green-500 font-medium">85 </span>
              <span class="text-500">responded</span>
          </div>
      </div>
  </div>
</div>
